<template>
    <el-dialog :visible="true" @close="handleCloseDialog" :close-on-click-modal="false" append-to-body title="轮播公告配置">
        <el-form label-position="left" label-width="80px">
             <el-form-item label="公告内容">
                <el-input v-model="tempText" />
            </el-form-item>

            <el-form-item label="背景色">
                <el-color-picker size="mini" :show-alpha="true" v-model="tempBackgroundColor"></el-color-picker>
            </el-form-item>

            <el-form-item label="字体颜色">
                 <el-color-picker size="mini" :show-alpha="true" v-model="tempColor"></el-color-picker>
            </el-form-item>
            

            <el-form-item label="字体">
                <el-select v-model="tempFontFamily" placeholder="请选择">
                    <el-option
                    v-for="item in fontsList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
                    <img :src="item.url" alt="" />
                    </el-option>
                </el-select>

            </el-form-item>

            <el-form-item label="预览">
                <div style="overflow: auto;height: 50px;line-height: 50px;font-size:40px;display: flex;height: 100%;justify-content: flex-start;">
                    <span  style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" 
                    :style="{color: tempColor, 'background-color': tempBackgroundColor, 'font-family': tempFontFamily}">{{tempText || '轮播公告内容尚未配置'}}</span>
                </div>

            </el-form-item>
        </el-form>


        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="onFinish()">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import fileSelector from "@client/components/file-selector";
import M from 'minimatch';


export default {
    name: "attr-qk-marquee",
    props: {
        text: {
            type: String,
            default: ''
        },
        backgroundColor: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: '#000'
        },
        fontFamily: {
            type: String,
            default: null
        }
    },
    components: {
    },
    data() {
        return {
            tempText: '',
            tempBackgroundColor: null,
            tempColor: null,
            tempFontFamily: null
        }
    },
    mounted() {
        this.tempText = this.text;
        this.tempBackgroundColor = this.backgroundColor;
        this.tempColor = this.color;
        this.tempFontFamily = this.fontFamily;
    },
    watch: {
        tempFontFamily: {
            async handler(fontFamily) {
                this.$store.dispatch('LOAD_FONT', {
                    fontFamily
                })
            },
        },
    },
    computed: {
        ...mapState({
            editActiveElement: state => state.editor.editActiveElement
        }),
        ...mapGetters([
            'activePage'
        ]),
        fontsList() {
            return this.$store.getters.getFontsList        
        }
    },
    methods: {
        onFinish() {

            let findResult = this.activePage.elements.some(element => {
                if (element.uuid === this.editActiveElement.uuid) {
                    element.propsValue.text = this.tempText;

                    element.commonStyle.color = this.tempColor;
                    element.commonStyle.backgroundColor = this.tempBackgroundColor;
                    element.commonStyle.fontFamily = this.tempFontFamily;

                    element.propsValue.color = element.commonStyle.color;
                    element.propsValue.backgroundColor = element.commonStyle.backgroundColor;
                    element.propsValue.fontFamily = element.commonStyle.fontFamily;

                    return true;
                }

                return false;
            });

            if (!findResult) {
                let newEle = _.cloneDeep(this.editActiveElement);
                newEle.propsValue.text = this.tempText;

                newEle.commonStyle.color = this.tempColor;
                newEle.commonStyle.backgroundColor = this.tempBackgroundColor;
                newEle.commonStyle.fontFamily = this.tempFontFamily;

                newEle.propsValue.color = newEle.commonStyle.color;
                newEle.propsValue.backgroundColor = newEle.commonStyle.backgroundColor;
                newEle.propsValue.fontFamily = newEle.commonStyle.fontFamily;

                this.activePage.elements.push(newEle);
            }

            this.$store.commit('addHistoryCache')
            this.handleCloseDialog();
        },
        handleCloseDialog() {
            this.$store.dispatch('editActiveElement', null);
        }
    }
}
</script>

<style lang="scss" >
.ql-editor {
    height: 300px;
}
</style>